import React, {Component} from 'react';
import './index.scss';
import Layout from './../../components/Layout/layout';
import neirong from './../../assets/index/neirong.png';

class Index extends Component {
    constructor(props) {
        super(props);
        this.state = {};

    }

    componentWillMount() {

    }

    componentDidMount() {

    }

    componentWillUnmount() {

    }

    // shouldComponentUpdate() {
    //
    // }

    render() {
        const {} = this.state;

        return (
            <Layout location={this.props.location}>
                <img className="content-img" src={neirong} alt=""/>
            </Layout>
        );
    }
}

export default Index;


// WEBPACK FOOTER //
// ./src/pages/Index/index.js
